import { message } from 'antd';
import { config } from "util/config";
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';
import { getUieDataSource } from 'components/UIBuilder/SectionFunction/Common';

//Search Address自动完成地址的数据源
export function searchAddressChange({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  switch (uie.source) {
    case 'SearchAddressFromHyperFlo':
      pageComponent.searchAddressFromHyperFlo(parameter);
      break;
    default:
      pageComponent.searchAddressFromPredictive(parameter);
      break;
  }
}

export function getAddressData({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.getAddressData(parameter);
}

export function selectAddressFromHyperFlo({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.selectAddressFromHyperFlo(parameter);
}

export function inspectionNameOnChange({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.inspectionNameOnChange({ sectionName, parameter, sectionComponent, pageComponent, uie });
}

export function scheduledTimeAmPmOnChange({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.scheduledTimeAmPmOnChange(parameter);
}

export function getLgaDataSource({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.getLgaDataSource(parameter, null);
}

//NewJob Form, 预设的几种 JobContact 选地址逻辑
export function searchAgentAddressChange({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.searchAddressFromPredictive(parameter, 'Agent_JobContactSearchAddress');
}

export function getAgentAddressData({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.getAddressData(parameter, 'Agent');
}

export function setAgentSameAsPropertyAddress({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter) {
    pageComponent.formRef.current?.setFieldValue('Agent_StreetNumber', pageComponent.formRef.current?.getFieldValue('PptStreetNumber'));
    pageComponent.formRef.current?.setFieldValue('Agent_StreetName', pageComponent.formRef.current?.getFieldValue('PptStreetName'));
    pageComponent.formRef.current?.setFieldValue('Agent_Suburb', pageComponent.formRef.current?.getFieldValue('PptSuburb'));
    pageComponent.formRef.current?.setFieldValue('Agent_State', pageComponent.formRef.current?.getFieldValue('PptState'));
    pageComponent.formRef.current?.setFieldValue('Agent_Postcode', pageComponent.formRef.current?.getFieldValue('PptPostcode'));
  } else {
    pageComponent.formRef.current?.setFieldValue('Agent_StreetNumber', '');
    pageComponent.formRef.current?.setFieldValue('Agent_StreetName', '');
    pageComponent.formRef.current?.setFieldValue('Agent_Suburb', '');
    pageComponent.formRef.current?.setFieldValue('Agent_State', '');
    pageComponent.formRef.current?.setFieldValue('Agent_Postcode', '');
  }
}

export function searchOwnerAddressChange({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.searchAddressFromPredictive(parameter, 'Owner_JobContactSearchAddress');
}

export function getOwnerAddressData({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.getAddressData(parameter, 'Owner');
}

export function setOwnerSameAsPropertyAddress({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter) {
    pageComponent.formRef.current?.setFieldValue('Owner_StreetNumber', pageComponent.formRef.current?.getFieldValue('PptStreetNumber'));
    pageComponent.formRef.current?.setFieldValue('Owner_StreetName', pageComponent.formRef.current?.getFieldValue('PptStreetName'));
    pageComponent.formRef.current?.setFieldValue('Owner_Suburb', pageComponent.formRef.current?.getFieldValue('PptSuburb'));
    pageComponent.formRef.current?.setFieldValue('Owner_State', pageComponent.formRef.current?.getFieldValue('PptState'));
    pageComponent.formRef.current?.setFieldValue('Owner_Postcode', pageComponent.formRef.current?.getFieldValue('PptPostcode'));
  } else {
    pageComponent.formRef.current?.setFieldValue('Owner_StreetNumber', '');
    pageComponent.formRef.current?.setFieldValue('Owner_StreetName', '');
    pageComponent.formRef.current?.setFieldValue('Owner_Suburb', '');
    pageComponent.formRef.current?.setFieldValue('Owner_State', '');
    pageComponent.formRef.current?.setFieldValue('Owner_Postcode', '');
  }
}

export function searchBuilderAddressChange({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.searchAddressFromPredictive(parameter, 'Builder_JobContactSearchAddress');
}

export function getBuilderAddressData({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.getAddressData(parameter, 'Builder');
}

export function setBuilderSameAsPropertyAddress({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  if (parameter) {
    pageComponent.formRef.current?.setFieldValue('Builder_StreetNumber', pageComponent.formRef.current?.getFieldValue('PptStreetNumber'));
    pageComponent.formRef.current?.setFieldValue('Builder_StreetName', pageComponent.formRef.current?.getFieldValue('PptStreetName'));
    pageComponent.formRef.current?.setFieldValue('Builder_Suburb', pageComponent.formRef.current?.getFieldValue('PptSuburb'));
    pageComponent.formRef.current?.setFieldValue('Builder_State', pageComponent.formRef.current?.getFieldValue('PptState'));
    pageComponent.formRef.current?.setFieldValue('Builder_Postcode', pageComponent.formRef.current?.getFieldValue('PptPostcode'));
  } else {
    pageComponent.formRef.current?.setFieldValue('Builder_StreetNumber', '');
    pageComponent.formRef.current?.setFieldValue('Builder_StreetName', '');
    pageComponent.formRef.current?.setFieldValue('Builder_Suburb', '');
    pageComponent.formRef.current?.setFieldValue('Builder_State', '');
    pageComponent.formRef.current?.setFieldValue('Builder_Postcode', '');
  }
}

export function setBuilderSameAsAgentOrOwner({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  console.log(pageComponent.formRef.current?.getFieldValue('ApplicantType'));
  if (parameter) {
    if (pageComponent.formRef.current?.getFieldValue('ApplicantType') === 0) {
      pageComponent.formRef.current?.setFieldValue('Builder_FirstName', pageComponent.formRef.current?.getFieldValue('Agent_FirstName'));
      pageComponent.formRef.current?.setFieldValue('Builder_LastName', pageComponent.formRef.current?.getFieldValue('Agent_LastName'));
      pageComponent.formRef.current?.setFieldValue('Builder_JobTitle', pageComponent.formRef.current?.getFieldValue('Agent_JobTitle'));
      pageComponent.formRef.current?.setFieldValue('Builder_Company', pageComponent.formRef.current?.getFieldValue('Agent_Company'));
      pageComponent.formRef.current?.setFieldValue('Builder_BusinessNo', pageComponent.formRef.current?.getFieldValue('Agent_BusinessNo'));
      pageComponent.formRef.current?.setFieldValue('Builder_Phone', pageComponent.formRef.current?.getFieldValue('Agent_Phone'));
      pageComponent.formRef.current?.setFieldValue('Builder_Mobile', pageComponent.formRef.current?.getFieldValue('Agent_Mobile'));
      pageComponent.formRef.current?.setFieldValue('Builder_Email', pageComponent.formRef.current?.getFieldValue('Agent_Email'));
      pageComponent.formRef.current?.setFieldValue('Builder_StreetNumber', pageComponent.formRef.current?.getFieldValue('Agent_StreetNumber'));
      pageComponent.formRef.current?.setFieldValue('Builder_StreetName', pageComponent.formRef.current?.getFieldValue('Agent_StreetName'));
      pageComponent.formRef.current?.setFieldValue('Builder_Suburb', pageComponent.formRef.current?.getFieldValue('Agent_Suburb'));
      pageComponent.formRef.current?.setFieldValue('Builder_State', pageComponent.formRef.current?.getFieldValue('Agent_State'));
      pageComponent.formRef.current?.setFieldValue('Builder_Postcode', pageComponent.formRef.current?.getFieldValue('Agent_Postcode'));
      pageComponent.formRef.current?.setFieldValue('Builder_Country', pageComponent.formRef.current?.getFieldValue('Agent_Country'));
    } else {
      pageComponent.formRef.current?.setFieldValue('Builder_FirstName', pageComponent.formRef.current?.getFieldValue('Owner_FirstName'));
      pageComponent.formRef.current?.setFieldValue('Builder_LastName', pageComponent.formRef.current?.getFieldValue('Owner_LastName'));
      pageComponent.formRef.current?.setFieldValue('Builder_JobTitle', pageComponent.formRef.current?.getFieldValue('Owner_JobTitle'));
      pageComponent.formRef.current?.setFieldValue('Builder_Company', pageComponent.formRef.current?.getFieldValue('Owner_Company'));
      pageComponent.formRef.current?.setFieldValue('Builder_BusinessNo', pageComponent.formRef.current?.getFieldValue('Owner_BusinessNo'));
      pageComponent.formRef.current?.setFieldValue('Builder_Phone', pageComponent.formRef.current?.getFieldValue('Owner_Phone'));
      pageComponent.formRef.current?.setFieldValue('Builder_Mobile', pageComponent.formRef.current?.getFieldValue('Owner_Mobile'));
      pageComponent.formRef.current?.setFieldValue('Builder_Email', pageComponent.formRef.current?.getFieldValue('Owner_Email'));
      pageComponent.formRef.current?.setFieldValue('Builder_StreetNumber', pageComponent.formRef.current?.getFieldValue('Owner_StreetNumber'));
      pageComponent.formRef.current?.setFieldValue('Builder_StreetName', pageComponent.formRef.current?.getFieldValue('Owner_StreetName'));
      pageComponent.formRef.current?.setFieldValue('Builder_Suburb', pageComponent.formRef.current?.getFieldValue('Owner_Suburb'));
      pageComponent.formRef.current?.setFieldValue('Builder_State', pageComponent.formRef.current?.getFieldValue('Owner_State'));
      pageComponent.formRef.current?.setFieldValue('Builder_Postcode', pageComponent.formRef.current?.getFieldValue('Owner_Postcode'));
      pageComponent.formRef.current?.setFieldValue('Builder_Country', pageComponent.formRef.current?.getFieldValue('Owner_Country'));
    }
  } else {
    pageComponent.formRef.current?.setFieldValue('Builder_FirstName', '');
    pageComponent.formRef.current?.setFieldValue('Builder_LastName', '');
    pageComponent.formRef.current?.setFieldValue('Builder_JobTitle', '');
    pageComponent.formRef.current?.setFieldValue('Builder_Company', '');
    pageComponent.formRef.current?.setFieldValue('Builder_BusinessNo', '');
    pageComponent.formRef.current?.setFieldValue('Builder_Phone', '');
    pageComponent.formRef.current?.setFieldValue('Builder_Mobile', '');
    pageComponent.formRef.current?.setFieldValue('Builder_Email', '');
    pageComponent.formRef.current?.setFieldValue('Builder_StreetNumber', '');
    pageComponent.formRef.current?.setFieldValue('Builder_StreetName', '');
    pageComponent.formRef.current?.setFieldValue('Builder_Suburb', '');
    pageComponent.formRef.current?.setFieldValue('Builder_State', '');
    pageComponent.formRef.current?.setFieldValue('Builder_Postcode', '');
    pageComponent.formRef.current?.setFieldValue('Builder_Country', '');
  }
}


//选择 ApplicantType 是否隐藏 Agent 部分
export function applicantTypeChange({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let webUIConfig = pageComponent.state.webUIConfig;
  webUIConfig.sectionList[0].componentList[0].groupList.map((group, i) => {
    if (parameter === 0) {
      group.show = true;
      if (group.name === 'Builder') {
        group.uieList.map((uie, i) => {
          if (uie.source === 'Builder_SameAsAgentOrOwner') {
            uie.title = "Same As Agent"
          }
          return uie;
        })
      }
    } else {
      if (group.name === 'Builder') {
        group.uieList.map((uie, i) => {
          if (uie.source === 'Builder_SameAsAgentOrOwner') {
            uie.title = "Same As Owner"
          }
          return uie;
        })
      }
      if (group.name === 'Agent') {
        group.show = false;
      }
    }
    return group;
  })
  pageComponent.setState({ webUIConfig });
}


//添加一组新的 Practitioner 控件
export function addAnotherPractitioner({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let webUIConfig = pageComponent.state.webUIConfig;
  let buildingPractitionerGroup = webUIConfig.sectionList[0].componentList[0].groupList.find(group => group.id === 'BuildingPractitioner');
  let counter = webUIConfig.sectionList[0].componentList[0].groupList.filter(group => group.id === 'BuildingPractitioner' || group.id === 'BuildingPractitionerCopy').length;
  if (counter < 5) {
    const newGroup = JSON.parse(JSON.stringify(buildingPractitionerGroup));
    newGroup.id = 'BuildingPractitionerCopy';
    newGroup.name = '';
    newGroup.buttonText = '';
    newGroup.buttonOnClick = '';
    newGroup.uieList.map((uie, i) => {
      const oldSource = uie.source;
      uie.source = uie.source + '_' + counter;

      if (uie.component === 'Select') {
        let componentDataSource = sectionComponent.state.componentDataSource;
        componentDataSource[uie.source] = JSON.parse(JSON.stringify(sectionComponent.state.componentDataSource[oldSource]));
        sectionComponent.setState({ componentDataSource });

        if (uie.type === 'group') {
          let dataSourceFilter = sectionComponent.state.componentDataSource[oldSource].filter(group => {
            return group.SelectOptionList !== null && group.SelectOptionList.length > 0;
          });
          if (dataSourceFilter.length > 0) {
            pageComponent.formRef.current?.setFieldValue(uie.source, dataSourceFilter[0].SelectOptionList[0].Value);
          } else {
            pageComponent.formRef.current?.setFieldValue(uie.source, sectionComponent.state.componentDataSource[oldSource][0]?.Value);
          }
        } else {
          pageComponent.formRef.current?.setFieldValue(uie.source, sectionComponent.state.componentDataSource[oldSource][0]?.Value);
        }
      }
    })

    const index = webUIConfig.sectionList[0].componentList[0].groupList.findIndex(group => group.id === 'BuildingPractitioner');
    webUIConfig.sectionList[0].componentList[0].groupList = [
      ...webUIConfig.sectionList[0].componentList[0].groupList.slice(0, index + 1),
      newGroup,
      ...webUIConfig.sectionList[0].componentList[0].groupList.slice(index + 1)
    ];

    pageComponent.setState({ webUIConfig });
  }
}

//Suburb 选择后快速填写数据
export function searchSuburbSelect({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie }) {
  let data = parameter;
  pageComponent.formRef.current?.setFieldValue('PptSuburb', data.data.Name);
  pageComponent.formRef.current?.setFieldValue('PptPostcode', data.data.Postcode);
}
